import React, { useContext } from 'react';
import { Field } from 'formik';
import { List, Row, Col } from 'antd';
import { TextField, PhoneNumberField } from 'components/Molecules/FormFields';
import classes from './SubForm.module.scss';
import { FormGenerateGccCpcDoc } from '../context/FormGenerateGccCpcDoc';

const SubTitle = {
  gcc: 'Third Party Laboratory',
  cpc: 'Third Party CPSC-Accepted Laboratory',
};

const LaboratoryInformation = () => {
  const { type } = useContext(FormGenerateGccCpcDoc);
  return (
    <Field name="laboratory">
      {({ field }) => {
        return (
          <div className={classes.laboratory}>
            <List
              itemLayout="vertical"
              split={false}
              dataSource={field.value || []}
              renderItem={(record, index) => {
                return (
                  <List.Item className={classes.item}>
                    <div className={classes.meta}>
                      <h5 className={classes.metaTitle}>{`#${index + 1}`}</h5>
                      <h5 className={classes.metaTitle}>{SubTitle[type]}</h5>
                    </div>
                    <div className={classes.content}>
                      <Row gutter={[16, 16]}>
                        <Col span={12}>
                          <TextField name={`laboratory.[${index}].name`} disabled label="Name" />
                        </Col>
                        <Col span={12}>
                          <PhoneNumberField
                            name={`laboratory.[${index}].phoneObj`}
                            label="Phone Number"
                            required
                          />
                        </Col>
                      </Row>
                      <TextField
                        name={`laboratory.[${index}].address`}
                        label="Address Line"
                        required
                      />
                      <TextField
                        name={`laboratory.[${index}].area`}
                        label="City / Region & Country"
                        required
                      />
                    </div>
                  </List.Item>
                );
              }}
            />
          </div>
        );
      }}
    </Field>
  );
};

export default LaboratoryInformation;
